import styled from 'styled-components';

export const Container = styled.div`
  .list-highlight {
    margin-bottom: 0;
    list-style-type: disc;
    list-style-position: inside;
  }

  .bidding {
    border-top-left-radius: 0;

    &-keyword {
      background: ${(props) => props.theme.$keyword};
    }

    &.bidding_selected {
      .bidding-bg-header {
        border-top-left-radius: 0 !important;
      }

      border-top-left-radius: 0;
      border-bottom-left-radius: 0;

      &::before {
        content: '';
        width: 7px;
        height: 100%;
        background: ${(props) => props.theme.$primary_green};
        position: absolute;
        left: -7px;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
      }
    }

    &-item-count {
      color: ${(props) => props.theme.$primary_green};
      font-weight: bold;
      font-size: 0.9em;
    }

    [class*='bidding-situation-'] {
      background-color: ${(props) => props.theme.$gray600};
      color: ${(props) => props.theme.$white};
      padding: 3px 7px;
    }

    .bidding-situation-nova {
      background-color: ${(props) => props.theme.$primary_green};
    }

    .bidding-situation-suspensa {
      background-color: ${(props) => props.theme.$warning};
      color: ${(props) => props.theme.$black};
    }

    .bidding-situation-suspensa-sine-die {
      background-color: ${(props) => props.theme.$warning};
      color: ${(props) => props.theme.$black};
    }

    .bidding-situation-urgente {
      background-color: ${(props) => props.theme.$danger};
    }

    &-info {
      &-border {
        border-top: 5px solid ${(props) => props.theme.$dark};
      }

      &-item-description {
        max-height: 400px;
        overflow: auto;
        word-break: normal;
        word-wrap: break-word;
        white-space: pre-wrap;
      }

      &-icon {
        font-size: 15px;
      }

      &-title {
        color: ${(props) => props.theme.$dark};
        font-weight: bold;
      }

      &-state {
        background: ${(props) => props.theme.$info};
        color: ${(props) => props.theme.$white};
        padding: 3px 5px;
      }

      a:hover {
        cursor: pointer;
      }
    }

    &-viewed {
      opacity: 30%;
      pointer-events: none;
    }
  }

  .history-arrow {
    font-size: 0.7em;
  }

  .item-arrow {
    font-size: 0.7em;
  }

  .item-highlight {
    em {
      background: ${(props) => props.theme.$keyword};
      padding: 0.2em;
    }
  }

  .highlight {
    background: ${(props) => props.theme.$keyword};
    padding: 0.2em;
  }

  @media print {
    @page {
      margin: 0.5cm;
    }
    .card.bidding {
      margin: 30px 15px 0 15px;
    }
    .bidding.bidding_selected::before {
      display: none;
    }

    .bidding-bg-header {
      background: ${(props) => props.theme.$white};

      .text-white {
        color: ${(props) => props.theme.$black} !important;
      }
    }

    .bidding-info-icon {
      display: none;
    }
  }
`;
